import {Button} from '@mui/material';
import {ModalError} from 'presentation/components/ModalError';
import {HomeEnum} from 'presentation/constants';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {translations} from 'presentation/translations-new';
import React, {Fragment, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {RequestSchedulePermissionProps} from './types';
import {goToRequestSchedule} from './utils';

const {filteredNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;
const {notice, close, goToHome} = translations['pt-br'].commons;

export function RequestSchedulePermission({
	requestAlreadyExists,
	requestCity,
}: RequestSchedulePermissionProps) {
	const navigate = useNavigate();
	const [openModalState, setOpenModalState] = useState<boolean>(false);
	const bookingData = useBookingStore(state => state.bookingData);

	const handleGoToHome = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	const handleGoToRequestSchedule = () => {
		if (requestAlreadyExists) {
			setOpenModalState(true);
			return;
		}
		goToRequestSchedule({
			bookingData,
			requestCity,
			navigate,
		});
	};

	return (
		<Fragment>
			<Button variant={'contained'} size="large" onClick={handleGoToRequestSchedule}>
				{filteredNetwork.requestSchedule}
			</Button>

			<ModalError
				isFullScreen={false}
				maxWidth={420}
				onClose={() => setOpenModalState(false)}
				headerTitle={notice}
				title={filteredNetwork.modalTitle}
				description={filteredNetwork.modalDescription}
				open={openModalState}
				firstButton={{
					title: goToHome,
					handleClick: handleGoToHome,
				}}
				secondButton={{
					title: close,
					handleClick: () => setOpenModalState(false),
				}}
			/>
		</Fragment>
	);
}
